// extracted by mini-css-extract-plugin
module.exports = {"card":"CookiePolicy_card__ZJaM2"};